import { useForm } from 'react-hook-form';
import { MasterMedicine } from '../../../apis/master-medicines/types';
import Yup from '../../../utils/yup';
import { yupResolver } from '@hookform/resolvers/yup';

const useMasterMedicineForm = (defaultValues?: MasterMedicine | null) => {
  return useForm<MasterMedicine>({
    defaultValues: defaultValues || {},
    resolver: yupResolver(schema)
  });
};

const schema = Yup.object().shape({
  name: Yup.string().required(),
  description: Yup.string().required(),
  image_url: Yup.string().required()
});

export default useMasterMedicineForm;
